import defaultLocale from '../locale/default';
let runtimeLocale = Object.assign({}, defaultLocale.Modal);
export const getModalLocale = () => {
    return Object.assign({}, runtimeLocale);
};
export const changeModalLocale = (locale) => {
    runtimeLocale = Object.assign(Object.assign({}, runtimeLocale), locale);
};
